import React, { Component } from 'react';
import { Field, reduxForm, FieldArray, formValueSelector } from 'redux-form';
import { FormattedMessage, injectIntl } from 'react-intl';
import isUndefined from 'lodash/isUndefined';
import get from 'lodash/get';

import ContactsImporter from '../../components/contacts-importer';
import Invitees from '../../components/purchase-claim/invitees';
import InviteesWithShare from '../../components/purchase-claim/invitees.with-share';
import ModalSplitForm from '../../containers/modal-split-form.container';
import Title from '../../components/title';
import ClaimPurchaseSummary from '../../components/purchase-claim/claim-purchase-summary';
import DuplicatedPurchase from './duplicated-purchase';
import Modal from '../../components/modal';

import SplitPurchase from '../../containers/split-purchase.container';
import OrganizerFields from '../../containers/purchase-claim/organizer-fields.container';

import FormField from '../form-field';
import Purchase from '../../lib/purchase';
import { CLAIM_NAMESPACE } from '../../actions';
import validate from './validate';
import '../../css/purchase-claim.css';

class PurchaseClaim extends Component {
  constructor(props) {
    super(props);

    this.onLanguageChange = this.onLanguageChange.bind(this);

    this.state = {
      showContactsImporter: false,
    };
  }


  onMinContributionChange(val) {
    this.props.change('organizerAllowedShareAmount', val);
    this.props.invitees.forEach((invitee, i) => {
      this.props.change(`invitees[${i}].allowedShareAmount`, val);
    });
  }

  onContactsImport(contacts) {
    const prevDraft = this.props.invitees || [];
    const prev = prevDraft.filter(c => c.email);

    this.props.array.removeAll('invitees');

    prev.forEach(invitee => this.props.array.push('invitees', invitee));

    contacts.forEach((contact) => {
      const newContact = {
        fullName: contact.fullName(),
        email: contact.selectedEmail(),
        allowedShareAmount: {
          amountCents: 0,
          currencyCode: this.props.purchase.currencyCode,
        },
      };
      this.props.array.push('invitees', newContact);
    });
  }

  onInviteesChange() {
    const invitees = this.props.invitees || [];
    const lastFilled = get(invitees[invitees.length - 1], 'email', false);

    if (lastFilled) {
      const newContact = {
        fullName: '',
        email: '',
        allowedShareAmount: {
          amountCents: 0,
          currencyCode: this.props.purchase.currencyCode,
        },
      };
      this.props.array.push('invitees', newContact);
    }

    this.hideContactsImportOptions();
  }

  onLanguageChange(ev) {
    const { target: { value } } = ev;
    const { accessToken } = this.props;
    this.props.updateUserLanguage(value, accessToken);
  }

  isShowingSpecifiedPerPerson() {
    const { splitType } = this.props;

    return Purchase.isSpecifiedPerPerson(splitType);
  }

  showContactsImportOptions() {
    this.setState({ showContactsImporter: true });
  }

  hideContactsImportOptions = () => {
    setTimeout(() => {
      this.setState({ showContactsImporter: false });
    }, 100);
  }

  renderContactsImportOptions() {
    if (!this.state.showContactsImporter) return null;
    return <ContactsImporter onImport={contacts => this.onContactsImport(contacts)} />;
  }

  renderInviteesFields() {
    const { currencyCode } = this.props.purchase;

    if (this.isShowingSpecifiedPerPerson()) {
      return (
        <FieldArray
          name="invitees"
          component={InviteesWithShare}
          onEmailFocus={() => this.showContactsImportOptions()}
          onEmailBlur={this.hideContactsImportOptions}
          onInviteesChange={() => this.onInviteesChange()}
          currency={currencyCode}
        />
      );
    }

    return (
      <FieldArray
        name="invitees"
        component={Invitees}
        onEmailFocus={() => this.showContactsImportOptions()}
        onEmailBlur={this.hideContactsImportOptions}
        onInviteesChange={() => this.onInviteesChange()}
      />
    );
  }

  renderDuplicatedPurchaseModal() {
    if (!this.props.isDuplicatedPurchaseModalVisible) return null;

    return (
      <Modal onClose={() => this.props.hideDuplicatedPurchaseModal()}>
        <DuplicatedPurchase
          duplicatedPurchase={this.props.duplicatedPurchase}
          ignoreDuplicatedPurchase={() => this.props.hideDuplicatedPurchaseModal()}
        />
      </Modal>
    );
  }

  renderEmailErrorsMessage({ meta }) {
    const { error = [] } = meta;
    const hasEmailError = error.reduce((hasError, fieldErrors, index) => {
      if (hasError) return true;

      const touched  = get(meta, `${index}.email.touched`, false);
      return touched && !isUndefined(fieldErrors.email);
    }, false);

    if (!hasEmailError) return null;

    return (
      <FormattedMessage
        id="claimForm.errors.invalidInviteeEmails"
        defaultMessage="Some emails you entered have errors.
        Check the ‘Email(s)’ field to correct them."
      >
        {(...message) => <span className="danger-print">{message}</span>}
      </FormattedMessage>
    );
  }

  renderForm() {
    const { handleSubmit, submitting } = this.props;

    return (
      <div className="purchase-claim justify-content-center">
        <form onSubmit={handleSubmit(this.props.onSubmit)}>
          <SplitPurchase
            onMinContributionChange={val => this.onMinContributionChange(val)}
            namespace={CLAIM_NAMESPACE}
          />

          <Title
            text={
              <FormattedMessage
                id="claimForm.yourGroup.title"
                defaultMessage="Your group"
              />
            }
            divider
          />

          <OrganizerFields />

          <Title
            text={
              <FormattedMessage
                id="claimForm.invitees.title"
                defaultMessage="Invitees"
              />
            }
            subtext={
              <FormattedMessage
                id="claimForm.invitees.subtext"
                defaultMessage="Optional - you can add more later"
              />
            }
          />

          <div className="mb-2">
            <div className="relative contacts-field-container">
              {this.renderInviteesFields()}
              {this.renderContactsImportOptions()}
            </div>
          </div>

          <Field
            name="personalMessage"
            label={
              <FormattedMessage
                id="claimForm.personalMessagefField.label"
                defaultMessage="Personal message"
              />
            }
            subtext={
              <FormattedMessage
                id="claimForm.personalMessageField.subtext"
                defaultMessage="Groups with a personal message are 42% more successful"
              />
            }
            type="textarea"
            className="mt-2"
            component={FormField}
          />

          <div className="row">
            <div className="col-12">
              <hr />
            </div>
            <div
              className="col-12 row"
              style={{
                justifyContent: 'space-between',
                paddingRight: 0
              }}
            >
              <div className="col-8">
                <Field
                  name="invitees"
                  component={this.renderEmailErrorsMessage}
                />
              </div>
              <div className="col-4" style={{paddingRight: 0}}>
                <button
                  type="submit"
                  className="btn btn-primary pull-right"
                  disabled={submitting}
                >
                  <FormattedMessage
                    id="claimForm.submit"
                    defaultMessage="Create group"
                  />
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    );
  }

  render() {
    return (
      <div>
        <ModalSplitForm
          leftForm={this.renderForm()}
          rightForm={<ClaimPurchaseSummary onLanguageChange={this.onLanguageChange} />}
        />
        {this.renderDuplicatedPurchaseModal()}
      </div>
    );
  }
}

export const FORM_NAME = 'purchaseClaim';
export const formSelector = formValueSelector(FORM_NAME);

export default injectIntl(reduxForm({
  form: FORM_NAME,
  validate,
  destroyOnUnmount: false,
})(PurchaseClaim));



// WEBPACK FOOTER //
// ./src/desktop/components/purchase-claim/index.js